import { render } from "./GtrBasicToLite.vue?vue&type=template&id=0cd8e521&ts=true"
import script from "./GtrBasicToLite.vue?vue&type=script&lang=ts"
export * from "./GtrBasicToLite.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__